var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.46921V4.04829L11 4.04826V3.46919L9 3.46921ZM12.5 4.04829V2.71918C12.5 2.52026 12.421 2.3295 12.2803 2.18884C12.1397 2.04819 11.9489 1.96917 11.75 1.96918L8.24999 1.96922C7.83578 1.96923 7.5 2.30501 7.5 2.71922V4.04831L4 4.04832C3.58578 4.04832 3.25 4.38411 3.25 4.79832V6.99998C3.25 7.19889 3.32902 7.38966 3.46967 7.53031C3.61032 7.67096 3.80109 7.74998 4 7.74998L4.55094 7.74998V15.6796C4.55094 16.2868 4.79213 16.8692 5.22153 17.2986C5.65091 17.728 6.2333 17.9692 6.84056 17.9692L13.1825 17.9692C13.7898 17.9692 14.3721 17.7279 14.8015 17.2985C15.2308 16.8692 15.4721 16.2868 15.4721 15.6796V7.74993L16 7.74993C16.4142 7.74993 16.75 7.41414 16.75 6.99993V4.79827C16.75 4.59936 16.671 4.40859 16.5303 4.26794C16.3897 4.12729 16.1989 4.04827 16 4.04827L12.5 4.04829ZM15.25 6.24994V5.54828L4.75 5.54832V6.24998L15.25 6.24994ZM12.5 7.74995L13.9721 7.74994V15.6796C13.9721 15.8889 13.8889 16.0898 13.7408 16.2379C13.5927 16.386 13.3919 16.4692 13.1825 16.4692L12.5 16.4692V7.74995ZM11 7.74995L9 7.74996V16.4692L11 16.4692V7.74995ZM7.5 16.4692V7.74997L6.05094 7.74997V15.6796C6.05094 15.889 6.13412 16.0899 6.28219 16.2379C6.43028 16.386 6.63115 16.4692 6.84056 16.4692L7.5 16.4692Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "a710cfed60e42d5c569652b72981efde.svg";
export { ForwardRef as ReactComponent };